import React, { useContext } from 'react';
import styled from 'styled-components';

import TypeBox from 'components/item/TypeBox';

import Box from 'components/shared/Box';
import Divider from 'components/shared/Divider';
import Header from 'components/shared/Header';
import Icon from 'components/shared/Icon';
import IsOwner from 'components/shared/IsOwner';

import { ModalContext } from 'components/shared/context/ModalContextProvider';

import add from 'images/add.svg';
import edit from 'images/edit.svg';

import Category from 'schema/category';

interface CategoryBoxProps {
  category: Category;
}

const CategoryBoxHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  align-items: flex-end;
`;

const NewTypeSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  align-items: center;
`;

const NewTypeText = styled.div`
  font-family: 'CircularStd-Medium';
  font-size: 15px;

  color: #a3a3a3;
`;

const CategoryBox: React.FC<CategoryBoxProps> = ({ category }) => {
  const { openEditCategoryModal, openAddTypeModal } = useContext(ModalContext);

  return (
    <Box>
      <CategoryBoxHeaderSection>
        <Header>{category.name}</Header>
        <IsOwner>
          <Icon
            src={edit}
            onClick={() => {
              openEditCategoryModal?.(category);
            }}
          />
        </IsOwner>
      </CategoryBoxHeaderSection>
      {category.types?.map((type, key) => {
        return <TypeBox type={type} key={key} />;
      })}
      <IsOwner>
        <Divider />
        <NewTypeSection
          onClick={() => {
            openAddTypeModal?.(category);
          }}
        >
          <NewTypeText>Add type</NewTypeText>
          <Icon src={add} />
        </NewTypeSection>
      </IsOwner>
    </Box>
  );
};

export default CategoryBox;
